<div class="telemetry-dashboard">
  <div class="dashboard-header">
    <h2>
      <i class="bi bi-broadcast"></i>
      {{ 'telemetry.headers.realtimeTelemetry' | transloco: { carId: carId } }}
    </h2>
  </div>

  <div class="dashboard-content">
    <!-- Seção do Mapa -->
    <div class="map-section">
      <div class="section-header">
        <h4><i class="bi bi-map"></i> {{ 'telemetry.headers.location' | transloco }}</h4>
      </div>
      <app-telemetry-map 
        [carId]="carId"
        [showHistory]="true"
        [showControls]="true"
        [height]="'500px'"
        (positionUpdated)="onDataReceived($event)">
      </app-telemetry-map>
    </div>

    <!-- Seção de Dados em Tempo Real -->
    <div class="data-section">
      <div class="section-header">
        <h4><i class="bi bi-speedometer2"></i> {{ 'telemetry.headers.vehicleData' | transloco }}</h4>
      </div>
      <app-telemetry-realtime 
        [carId]="carId"
        [autoConnect]="true"
        (dataReceived)="onDataReceived($event)">
      </app-telemetry-realtime>
    </div>
  </div>
</div>
